// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analysis-progress-container {
  margin-top: 30px;
  padding: 20px;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.progress-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.progress-status {
  flex: 1 1;
}

.status-text {
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
}

.progress-info {
  font-size: 0.9rem;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/components/AnalysisProgress.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".analysis-progress-container {\n  margin-top: 30px;\n  padding: 20px;\n  background-color: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n}\n\n.progress-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.progress-status {\n  flex: 1;\n}\n\n.status-text {\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.progress-info {\n  font-size: 0.9rem;\n  color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
